import React from 'react';

const RolesPageConfig = {
	settings: {
		layout: {
			config: {
				adminPage: true,
			},
		},
	},
	routes: [
		{
			path: '/admin/roles',
			exact: true,
			component: React.lazy(() => import('./RolesPage')),
		},
	],
};

export default RolesPageConfig;
